import React, { useState } from "react";
import { Box, Typography, Paper, Divider, List, ListItem, ListItemText, Button } from "@mui/material";

export const AdditionalFringeCard = ({ explanation }) => {
  const [expanded, setExpanded] = useState(false);

  const lines = explanation.split("\n").filter(line => line.trim() !== "");
  const bulletItems = lines.filter(line => line.startsWith("-"));
  const nonBulletLines = lines.filter(line => !line.startsWith("-") && !line.includes("Additional fringe window :"));
  const additionalLines = nonBulletLines.slice(2);

  return (
    <Paper
      sx={{
        p: 2,
        border: "1px solid #03A9F4",
        borderRadius: 1,
        fontFamily: "Poppins, sans-serif",
        position: "relative",
        mt: 2
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography fontWeight="bold">Additional Fringe Calculation Explanation</Typography>
        <Button
          variant="outlined"
          size="small"
          onClick={() => setExpanded(prev => !prev)}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.60rem",
            minWidth: "auto",
            borderColor: "#1976d2",
            color: "#1976d2",
            "&:hover": {
              borderColor: "#1565c0",
              backgroundColor: "rgba(25, 118, 210, 0.04)"
            }
          }}
        >
          {expanded ? "View less" : "View more"}
        </Button>
      </Box>

      <Divider sx={{ my: 1.5 }} />

      <Typography sx={{ mb: 0.5 }}>{nonBulletLines[0]}</Typography>
      <Typography sx={{ mb: 0.5 }}>Additional fringe window :</Typography>

      <List dense sx={{ pl: 2, mt: 1 }}>
        {bulletItems.map((item, idx) => (
          <ListItem key={idx} disablePadding>
            <ListItemText primary={item.replace(/^- /, "")} />
          </ListItem>
        ))}
      </List>

      {expanded &&
        additionalLines.map((line, index) => (
          <Typography key={index} sx={{ mt: 1 }}>
            {line}
          </Typography>
        ))}
    </Paper>
  );
};
